<template>
  <div class="sidebar-wedget-wrap">
    <div class="sidebar-wedget internet">
      <span class="top-title">خدمات البث</span>
      <h2>
        تجربة مشاهدة بلا حدود: اكتشف عالم الترفيه الرقمي الفائق
      </h2>
    </div>
    <div class="sidebar-wedget">
      <span class="top-title">خدمات أخرى</span>
      <ul class="ps-0 mb-0 list-unstyled services">
        <li>
          <RouterLink
            to="/services-details"
            class="d-flex justify-content-between align-items-center"
          >
            <span class="name">باقات IPTV</span>
            <i class="ri-arrow-right-s-fill"></i>
          </RouterLink>
        </li>
        <li>
          <a
            href="/services-details"
            class="d-flex justify-content-between align-items-center"
          >
            <span class="name">القنوات الرياضية</span>
            <i class="ri-arrow-right-s-fill"></i>
          </a>
        </li>
        <li>
          <a
            href="/services-details"
            class="d-flex justify-content-between align-items-center"
          >
            <span class="name">مكتبة الأفلام</span>
            <i class="ri-arrow-right-s-fill"></i>
          </a>
        </li>
        <li>
          <a
            href="/services-details"
            class="d-flex justify-content-between align-items-center"
          >
            <span class="name">الدعم الفني والتقني</span>
            <i class="ri-arrow-right-s-fill"></i>
          </a>
        </li>
        <li>
          <a
            href="/services-details"
            class="d-flex justify-content-between align-items-center"
          >
            <span class="name">إعداد الشاشات الذكية</span>
            <i class="ri-arrow-right-s-fill"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SidebarWidget",
});
</script>